'use client'
import styled from 'styled-components'
import { mq, vw, designGrid, getP114, getP93_1 } from '@/styles'

export const HeaderContents = styled.header`
  ${designGrid({})}
  align-content: flex-end;
  align-items: center;
  margin-bottom: ${vw(48, 'mobile')};
  padding: ${vw(144, 'mobile')} ${vw(20, 'mobile')} 0;

  ${mq.greaterThan('nexus7')} {
    margin-bottom: ${vw(48, 'tablet')};
    padding: ${vw(144, 'tablet')} ${vw(20, 'tablet')} 0;
  }

  ${mq.greaterThan('tablet')} {
    margin-bottom: ${vw(60, 'desktop')};
    padding:  ${vw(176, 'desktop')} 0 0;
  }

  ${mq.greaterThan('desktop')} {
    margin-bottom: 60px;
    padding:  176px 0 0;
  }

  h1, p {
    grid-column: 1 / span 6;
    text-align: center;
    width: 100%;
  }

  h1 {
    color: var(--color-red);
    font-family: var(--font-manic);
    ${getP114()}
    font-weight: 400;
    margin-bottom: ${vw(25, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(25, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      grid-column: 3 / span 8;
      margin-bottom: ${vw(30, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 30px;
    }
  }

  p {
    color: var(--color-red);
    font-family: var(--color-platform);
    ${getP93_1()}
    font-weight: bold;
    margin-bottom: 0;

    ${mq.greaterThan('tablet')} {
      grid-column: 2 / span 10;
      padding: 0 ${vw(60, 'desktop')};
    }
  }
`
